import styled, { css } from 'styled-components';

import { MessageReactionsWrapper } from '../MessageReactions/MessageReactions.styled';
import { MessageProps } from './Message';
import { MESSAGE_ROLE } from './types/messages';

export const MessageContainerWrapper = styled.div`
  overflow-y: auto;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

export const MessageWrapper = styled.div<{ $type: MessageProps['type'] }>`
  ${({ theme, $type }) => css`
    display: flex;
    flex-direction: column;
    align-items: ${$type === MESSAGE_ROLE.USER ? 'flex-end' : 'flex-start'};
    margin: 1em;
    min-width: 250px;
    word-wrap: break-word;
    word-break: break-word;
    scroll-margin-top: 16px;
    scroll-margin-bottom: 16px;

    & > div:first-child {
      flex: 0 1 auto;
      max-width: 35em;
      padding: 1em;
      line-height: 140%;
      border-radius: 4px;

      color: ${$type === MESSAGE_ROLE.USER
        ? theme.color.userMessage
        : theme.color.assistantMessage};
      background-color: ${$type === MESSAGE_ROLE.USER
        ? theme.color.userMessageBG
        : theme.color.assistantMessageBG};
      filter: ${$type === MESSAGE_ROLE.USER
        ? 'none'
        : 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.44));'};
      -webkit-filter: ${$type === MESSAGE_ROLE.USER
        ? 'none'
        : 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.44));'};

      & > *:not(${MessageReactionsWrapper}) {
        ${$type !== MESSAGE_ROLE.SYSTEM ? 'margin: 0;' : ''}
      }
    }
  `}
`;

export const MessageAlertWrapper = styled.div`
  margin-top: 6px;
  margin-left: 6px;
  font-size: 14px;

  .alert {
    margin-bottom: unset;
  }

  .hl-alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const RetryButton = styled.button`
  font-weight: 600;
  color: ${({ theme }) => theme.color.retryButton};
  padding-left: 16px;
`;

export const LoadingMessageWrapper = styled(MessageWrapper)`
  & > div {
    min-width: fit-content;
  }
`;

const animationTimeMillis = 400;

export const EllipsesWrapper = styled.div`
  height: 15px;
  width: 25px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 5px;

  span {
    width: 5px;
    height: 5px;
    background: ${({ theme }) => theme.color.loadingEllipses};
    border-radius: 5px;
    animation: blink ${animationTimeMillis}ms infinite alternate;
    @media (prefers-reduced-motion) {
      animation: blink 1000ms infinite alternate;
    }
  }

  @keyframes blink {
    0% {
      opacity: 0.3;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  span:nth-of-type(2) {
    animation-delay: ${animationTimeMillis / 4}ms;
  }
  span:nth-of-type(3) {
    animation-delay: ${animationTimeMillis / 2}ms;
  }
`;
